import { render } from "./languageSwitcher.vue?vue&type=template&id=02f8dcc4&scoped=true"
import script from "./languageSwitcher.vue?vue&type=script&lang=js"
export * from "./languageSwitcher.vue?vue&type=script&lang=js"

import "./languageSwitcher.vue?vue&type=style&index=0&id=02f8dcc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f8dcc4"]])

export default __exports__